import styled  from 'styled-components'

export const StyledTextWrapper = styled.div`
  align-self: center;
  
  a {
    text-decoration: none;
    max-width: 320px; 
    display: block;
  }
`

export const StyledText = styled.p`
  font-size: 14px;
  text-align: center;
  line-height: 145%;
  margin: 0;
`